import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

@Component({

   selector: 'page-dropdown-popover',
   templateUrl: 'dropdown-popover.html'
})

export class DropdownPopoverPage
{

   private choices = [];
   private callback;


   /** ----- Constructor ----- **/

   constructor( private viewCtrl: ViewController, private params: NavParams )
   {

      this.choices = this.params.get( 'choices' );
      this.callback = this.params.get( 'callback' );

   }


   /** ----- View LifeCycle ----- **/

   onClicked( inIdx )
   {

      this.callback( inIdx ).then( () => {

         this.viewCtrl.dismiss();
      });

   }

}



// WEBPACK FOOTER //
// ./src/pages/dropdown-popover/dropdown-popover.ts